module.exports = __webpack_public_path__ + "static/media/4.c832a2c0.svg";